import { gql } from '@apollo/client';

// DD-3698 Find customer: clinics and labs a lab can make its customers. `services` is the
// customer types, under the name the shared directory browser reads for its pills and chips.
export const customerDirectoryTemplate = gql`
    query customerDirectory(
        $search: SearchString
        $country: String
        $services: [CustomerDirectoryType!]
        $sort: SupplierDirectorySort
        $maxDistanceKm: Int
        $onlyLocated: Boolean
        $limit: Int
        $offset: Int
    ) {
        customerDirectory(
            search: $search
            country: $country
            customerTypes: $services
            sort: $sort
            maxDistanceKm: $maxDistanceKm
            onlyLocated: $onlyLocated
            limit: $limit
            offset: $offset
        ) {
            total
            ownLocationKnown
            country
            labs {
                _id
                name
                organizationNumber
                street
                zip
                city
                phone
                email
                website
                logoSignedUrl
                staffSignedUrl
                shortDescription
                description
                openingHours {
                    day
                    time {
                        from
                        to
                    }
                    active
                }
                geoLocation {
                    latitude
                    longitude
                }
                services: customerTypes
                parent {
                    _id
                    name
                    customerType
                    clinicCount
                }
                clinicCount
                distanceKm
                connection
                isActionBased
            }
        }
    }
`;
